import './MyBlockMonthOverview.scss'
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { blockType } from '../../constants/myBlockMonth';
import { useMyBlockMonthProvider } from '../../providers/MyBlockMonthProvider';

const MyBlockMonthBody = ({datesDropDownIndex, isNonBidder, noData}) => { 
    const { t } = useTranslation();
    const myBlockMonthContext = useMyBlockMonthProvider();
    const blockMonthType = myBlockMonthContext.myBlockMonthData?.blockList?.BLOCK_TYPE_MNT ?? 'N/A';

    const showOverviewData = () => {
        if(isNonBidder) return true;
        if(noData) return false;
        return true;
    }
    
    return (
        <>
            {showOverviewData() && (
                <div className="c-mbm-overview">
                    <div className="c-inner">
                        <div className="c-data">
                            <div className="data__section-one">
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        {datesDropDownIndex === 0 
                                        ? <span className="data__lbl">{t('myBlockMonth.totalProjectedHours')}: </span>
                                        :<span className="data__lbl">{t('myBlockMonth.totalCreditedHours')}: </span>}
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.totalProjectedHours?.length > 0 ? myBlockMonthContext.myBlockMonthData?.blockList?.totalProjectedHours : 'N/A'}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span className="data__lbl">{t('myBlockMonth.daysOn')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.daysOn ?? ''}</span>
                                    </Grid>
                                    <Grid item xs={4} className="ipad-view--margin">
                                        <span className="data__lbl">{t('myBlockMonth.sickDays')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.sickDays ?? ''}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span className="data__lbl">{t('myBlockMonth.availableHours')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.availableHours ?? ''}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span className="data__lbl">{t('myBlockMonth.daysOff')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.daysOff ?? ''}</span>
                                    </Grid>
                                    <Grid item xs={4} className="ipad-view--margin">
                                        <span className="data__lbl">{t('myBlockMonth.vacationDays')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.vacationDays ?? ''}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        {/* TODO- pay protection bucket shows up once the user accepts pay protection for the month */}
                                        {/* <span className="data__lbl">{t('myBlockMonth.tafb')}: </span> */}
                                        {/* <span>{myBlockMonthContext.myBlockMonthData.blockList.tafb}</span> */}
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span className="data__lbl">{t('myBlockMonth.tafb')}: </span>
                                        <span>{myBlockMonthContext.myBlockMonthData?.blockList?.tafb ?? ''}</span>
                                    </Grid>
                                </Grid>
                            </div>
                            {/* <span className="data__section-divider" />
                            <div className="data__section-two">
                                <span className="data__lbl">{t('myBlockMonth.initialExpenses')}: </span>
                                &nbsp;
                                <span>{myBlockMonthContext.myBlockMonthData?.blockList?.totalExpenses ?? ''}</span>
                            </div> */}
                        </div>
                        <div className="dbm-mbg">
                            <Link to="/dbm">{t('myBlockMonth.dbm')} = {myBlockMonthContext?.myBlockMonthData?.dbm ?? ''}</Link>
                            <Link to="/dbm">
                                {blockMonthType === blockType.RESERVE 
                                    ? t('myBlockMonth.rsvmbg') 
                                    : blockMonthType === blockType.NONBIDDER 
                                        ? t('myBlockMonth.nonBidderMbg') 
                                        : t('myBlockMonth.mbg')} = {myBlockMonthContext?.myBlockMonthData?.mbg ?? ''
                                }
                            </Link>               
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default MyBlockMonthBody;
